import type { SearchRequestBody, SearchResponse } from "../types";
import { rootApi } from "../../../api";

export const searchApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<SearchResponse, SearchRequestBody>({
      query: (requestBody) => ({
        url: "/search",
        method: "POST",
        body: requestBody,
      }),
      providesTags: ["search"],
    }),
  }),
});

export const { useLazySearchQuery } = searchApi;
